import React, { use } from "react";
import "../styles/SignUpStatement.css";
import SignInInput from "./SignInInput.js";
import { useState } from "react";

function SignUpStatement() {
  const [hidesignupdiv, setHideSignUpdiv] = useState(false);
  return (
    <div className="signin-signup-container">
      <div
        className={`dont-have-acc-container ${hidesignupdiv ? "hidden" : ""}`}
      >
        <div
          className="dont-have-acc-container-text"
          style={{ display: hidesignupdiv ? "none" : "block" }}
        >
          Don’t have an account?
        </div>
        <div
          className="dont-have-acc-container-link"
          style={{ display: hidesignupdiv ? "none" : "block" }}
          onClick={() => {
            window.open(
              `${process.env.REACT_APP_DEV_ENVIROMET_URL}/register`,
              "_blank",
            );
          }}
        >
          Sign UP
        </div>
      </div>
      <SignInInput onhidesignupdiv={() => setHideSignUpdiv(true)} />
    </div>
  );
}
export default SignUpStatement;
